module.exports = __webpack_public_path__ + "static/img/101223.4e7b7592.png";